import { render, staticRenderFns } from "./VehicleEditPage.vue?vue&type=template&id=12784462&"
import script from "./VehicleEditPage.vue?vue&type=script&lang=js&"
export * from "./VehicleEditPage.vue?vue&type=script&lang=js&"
import style0 from "./VehicleEditPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports